import React from "react";
import Note from "./Note";

function NotesList({ notes, deleteNote, editNote, togglePin }) {
  return (
    <div className="notes-container">
      {notes.map((note) => (
        <Note
          key={note.id}
          note={note}
          deleteNote={deleteNote}
          editNote={editNote}
          togglePin={togglePin}
        />
      ))}
    </div>
  );
}

export default NotesList;